import { render } from "./Aside.vue?vue&type=template&id=89b7891c&scoped=true&ts=true"
import script from "./Aside.vue?vue&type=script&lang=ts"
export * from "./Aside.vue?vue&type=script&lang=ts"

import "./Aside.vue?vue&type=style&index=0&id=89b7891c&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b7891c"]])

export default __exports__